var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigate-container",attrs:{"data-app":""}},[_c('div',[_c('h4',[_vm._v(" "+_vm._s(_vm.title.replace(/\"/g, ""))+" ")])]),_c('div',[_c('el-button',{staticClass:"mt-12 submit-button",attrs:{"type":"primary"},on:{"click":function($event){return _vm.goHome()}}},[_vm._v(_vm._s(_vm.$t("wap.text26")))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }